import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { EmptyState } from '../ui/EmptyState';
import { Icon } from '../ui/Icon';
import { frozenModuleForPath } from '../../lib/frozen';

/**
 * FASE 0 — Gate delle route dei moduli in pausa (fonte: lib/frozen.ts).
 *
 * Route senza path che avvolge le pagine dell'AppShell in App.tsx: se il path
 * corrente appartiene a un modulo in FROZEN_MODULES mostra la pagina di pausa,
 * altrimenti lascia passare la pagina reale (<Outlet />). Ragiona sul path,
 * quindi copre link interni, palette, stream Oggi e URL digitati a mano.
 */
export function FrozenGate() {
  const { pathname } = useLocation();
  return frozenModuleForPath(pathname) ? <FrozenPage /> : <Outlet />;
}

function FrozenPage() {
  const navigate = useNavigate();
  return (
    <div className="page">
      <div className="max-w-[480px] mx-auto py-20">
        <EmptyState
          icon="clock"
          title="Modulo in pausa"
          description="Questa sezione è ferma mentre costruiamo Task e Amministrazione. I dati restano al sicuro e tornano disponibili quando la riattiviamo."
          action={
            <button className="btn btn-primary" onClick={() => navigate('/')}>
              <Icon name="arrowLeft" size={14} /> Torna a Oggi
            </button>
          }
        />
      </div>
    </div>
  );
}
